import React, { useState } from 'react';

import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

import TextInput from '../../components/Controls/TextInput/TextInput';
import SelectField from '../../components/Controls/SelectField/SelectField';

import { FILER_TYPES } from '../../common/filterTypes';

const FiltersModal = ({ currentFilters, onSaveClicked, onDiscardClicked, baseFiltersData }) => {
    const [filters, setFilters] = useState({ ...currentFilters });

    const onFieldChanged = (fId, newVal) => {
        const newFilters = { ...filters };
        newFilters[fId] = { ...filters[fId], value: newVal };
        setFilters(newFilters);
    };

    const clearFilters = () => {
        setFilters({ ...baseFiltersData });
    };

    const filtersBody = Object.keys(filters).map((filterId) => {
        const filter = filters[filterId];
        if (filter.type.id === FILER_TYPES.INPUT.id) {
            const field = {
                id: filterId,
                name: filter.name,
                value: filter.value
            };
            return <TextInput key={filterId} field={field} changed={onFieldChanged} />;
        } else {
            const field = {
                id: filterId,
                name: filter.name,
                value: filter.value
            };
            return (
                <SelectField
                    key={filterId}
                    field={field}
                    options={filter.options}
                    clearable={filter.clearable}
                    changed={onFieldChanged}
                />
            );
        }
    });
    return (
        <Modal
            id={'styles.adServersSelectorModal'}
            show={true}
            onHide={onDiscardClicked}
            keyboard={true}
            backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{'Filters'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={'styles.dataContainer'}>{filtersBody}</div>
            </Modal.Body>
            <Modal.Footer>
                <div className={'styles.footerButtons'}>
                    <Button onClick={clearFilters}>Clear All</Button>
                    <Button onClick={onDiscardClicked}>Cancel</Button>
                    <Button
                        bsStyle="success"
                        onClick={() => {
                            onSaveClicked(filters);
                        }}
                        disabled={false}>
                        Done
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default FiltersModal;
